import { SiteUser } from '../../models/usersites.model';
import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { UserService } from '../../services/user.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { MaterialModule } from '../../../material/material.module';

@Component({
  selector: 'app-user-sites-assign-dialog',
  templateUrl: './user-sites-assign-dialog.component.html',
  styleUrls: ['./user-sites-assign-dialog.component.scss'],
})
export class UserSitesAssignDialogComponent implements OnInit {
  dataSource!: MatTableDataSource<SiteUser>;
  selection = new SelectionModel<SiteUser>(true, []);

  displayedColumns: string[] = ['select',
    'locationName'
  ];

  assignSitesForm!: FormGroup;
  userSites!: SiteUser[];
  constructor(public dialogRef: MatDialogRef<UserSitesAssignDialogComponent>,
    private fb: FormBuilder,
    private userService: UserService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.assignSitesForm = this.fb.group({
      id: [''],
      userId: [''],
      siteId: [''],
      locationName: [''],
      canView: ['']
    });

    // this.userService.getSiteByUserId(this.data.userId).subscribe((response: SiteUser[]) => {
    //   this.userSites = response;
    //   this.dataSource = new MatTableDataSource(response);

    //   this.selection = new SelectionModel<SiteUser>(true, response.filter(x => x.canView === true));
    // });
  }

  save() {

    if (this.selection.selected?.length > 0) {
      this.selection.selected.forEach(element => {
        element.canView = true;
      });

      this.userService.saveSiteUser(this.selection.selected).subscribe();
    } else {
      const siteUser: SiteUser[] = [{ id: 0, locationName: '', siteId: 0, userId: this.data.userId, canView: false }];
      this.userService.saveSiteUser(siteUser).subscribe();
    }
  }

  onClose() {
    this.dialogRef.close();

  }

  get hasRows() {
    return this.userSites?.length !== 0;
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


}
